export default {
  //课中活动讨论
  mutualEvaluateInfo: {
    detail:'',
    stuOrGroup:''
  },
  mutualEvaluateList: '',
   //过程性评价
   scoreStuRecordInfo: {
    detail:'',
  },
  scoreStuRecordList: '',
}
